import { Grid, GridColumn, GridDetailExpandChangeEvent } from '@progress/kendo-react-grid';
import React, { FC, useState } from 'react';
import { POHistoryHeader } from 'src/types/poHistory';
import POHistoryDetailGrid from './POHistoryDetailGrid';
import { DetailExpandDescriptor } from '@progress/kendo-react-data-tools';

interface Props {
  poHistory: POHistoryHeader[] | null;
}

const POHistoryGrid: FC<React.PropsWithChildren<Props>> = ({ poHistory }) => {
  const [expandedDetailState, setExpandedDetailState] = useState<DetailExpandDescriptor>({});

  const handleDetailExpandChange = (event: GridDetailExpandChangeEvent) => {
    setExpandedDetailState(event.detailExpand);
  };

  return (
    <Grid data={poHistory} detail={POHistoryDetailGrid} detailExpand={expandedDetailState} onDetailExpandChange={handleDetailExpandChange}>
      <GridColumn field="date" title="Date/Time" />
      <GridColumn field="action" title="Action" />
      <GridColumn field="notes" title="Notes" />
      <GridColumn field="createdBy" title="Created By" />
      <GridColumn field="acknowledgedBy" title="Acknowledged By" />
      <GridColumn field="ackDateTime" title="Ack Date/Time" />
    </Grid>
  );
};

export default POHistoryGrid;
